/**
 * Kategorileri API'den hiyerarşik yapıda getirir
 *
 * @param {Object} options - Yapılandırma seçenekleri
 * @param {Object} options.axios - Axios örneği
 * @param {Object} options.settings - URL ayarları
 * @param {String} options.assetId - Geçerli varlık ID'si
 * @returns {Promise<Array>} - Ham kategori verileri
 */
export const fetchCategories = async (options) => {
  const { axios, assetId, settings } = options;
  
  try {
    // Doğru endpoint ve parametre ismi kullanarak kategorileri al
    const response = await axios.get(settings.getDocumentCategories, {
      params: {
        asset_id: assetId, // Backend'in beklediği formatta parametre adı
      },
    });

    if (response?.data?.data) {
      return response.data.data;
    }
    
    return [];
  } catch (error) {
    console.error('Kategoriler getirilirken hata oluştu:', error);
    
    // Birincil başarısız olursa yedek endpoint'i dene
    try {
      const fallbackResponse = await axios.get(settings.keywordCategories, {
        params: {
          asset_id: assetId,
        },
      });

      if (fallbackResponse?.data?.data) {
        return fallbackResponse.data.data;
      }
      
      return [];
    } catch (fallbackError) {
      console.error('Yedek kategori getirme hatası:', fallbackError);
      throw error;
    }
  }
}